import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useSuppliers(family, input = "", category = "") {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarProveedores.php", {
      token: userData.token,
      familia: family,
      inputFiltro: input,
      categoria: category,
    });
    // console.log(
      // "LISTAR PROVEEDORES: ",
      // {
        // token: userData.token,
        // familia: family,
        // inputFiltro: input,
        // categoria: category,
      // },
      // response,
    // );
    setList(response);
  }

  useEffect(() => {
    getData();
  }, [family, input, category]);

  return [list, getData];
}
